// Runtime webpack config
import '../../other/WebpackConfig';

import '../../../scss/l1CarsPage.twh.nlbe.scss';

// i18n
import i18n from '../../i18n/nl-BE';

import l1CarsPage from './l1CarsPage';

l1CarsPage(i18n);
